import axiosInstance, { API_ROUTES } from '../lib/http/httpRequest';
import { AxiosResponse } from 'axios';
import { ConnectedTwitterData, MemberSettings, Profile } from '@/state/member/memberTypes';
import { AuthorizationTokens } from '@/state/auth/authTypes';

interface ConnectTwitterUserPayload {
    oauthToken: string;
    oauthVerifier: string;
}

export const changeEmail = (payload: {
    email: string;
    userPassword: string;
}): Promise<AxiosResponse<void>> =>
    axiosInstance.put(`${API_ROUTES.SETTINGS}/changeEmail`, payload);
export const changePassword = (payload: {
    password: string;
    userPassword: string;
}): Promise<AxiosResponse<{ authorization: AuthorizationTokens }>> =>
    axiosInstance.put(`${API_ROUTES.SETTINGS}/changePassword`, payload);
export const changeUsername = (payload: { username: string }): Promise<AxiosResponse<void>> =>
    axiosInstance.put(`${API_ROUTES.SETTINGS}/changeUsername`, payload);
export const deleteAccountApi = (): Promise<AxiosResponse<void>> =>
    axiosInstance.delete(`${API_ROUTES.SETTINGS}/account`);
export const setSettings = (
    payload: Partial<MemberSettings>,
): Promise<AxiosResponse<MemberSettings>> => axiosInstance.put(`${API_ROUTES.SETTINGS}`, payload);
export const getAllSettings = (): Promise<AxiosResponse<MemberSettings>> =>
    axiosInstance.get(`${API_ROUTES.SETTINGS}`);

export const downgradeToBasic = (): Promise<AxiosResponse<void>> =>
    axiosInstance.post(`${API_ROUTES.SETTINGS}/account-types/downgrade`, { accountType: 'basic' });

export const getMenuOrder = (): Promise<AxiosResponse<{ menuOrder: any }>> =>
    axiosInstance.get(`${API_ROUTES.SETTINGS}/menu`);
export const updateMenuOrder = (payload: { menuOrder: string }): Promise<AxiosResponse<void>> =>
    axiosInstance.put(`${API_ROUTES.SETTINGS}/menu`, payload);
export const getConnectedTwitterData = (): Promise<AxiosResponse<ConnectedTwitterData>> =>
    axiosInstance.get(`${API_ROUTES.TWITTER}`);
export const disconnectTwitterUser = (): Promise<AxiosResponse<void>> =>
    axiosInstance.post(`${API_ROUTES.TWITTER_DISCONNECT}`);
export const getTwitterRequestTokenApi = (): Promise<AxiosResponse<{ oauthToken: string }>> =>
    axiosInstance.get(`${API_ROUTES.TWITTER_REQUEST_TOKEN}`);
export const connectTwitterUser = (
    payload: ConnectTwitterUserPayload,
): Promise<AxiosResponse<ConnectedTwitterData>> =>
    axiosInstance.post(`${API_ROUTES.TWITTER_CONNECT}`, payload);
export const syncDataWithTwitter = (): Promise<AxiosResponse<ConnectedTwitterData>> =>
    axiosInstance.get(`${API_ROUTES.TWITTER_SYNC}`);
export const getMemberProfile = (): Promise<AxiosResponse<Profile>> =>
    axiosInstance.get(`${API_ROUTES.SETTINGS}/profile`);

export const connectTelegram = (payload: { token: string }): Promise<AxiosResponse<any>> =>
    axiosInstance.post(`${API_ROUTES.TELEGRAM}/connect`, payload);

export const getTelegramChats = (): Promise<AxiosResponse<any>> =>
    axiosInstance.get(`${API_ROUTES.TELEGRAM}/my/chats`);

export const deleteTelegramConnection = (): Promise<AxiosResponse<any>> =>
    axiosInstance.delete(`${API_ROUTES.TELEGRAM}/my/chats`);

export const subscribePushToken = (payload: {
    token: string;
    deviceType: 'ios' | 'andrdoid' | 'web';
}): Promise<AxiosResponse<void>> => axiosInstance.post('/push-notifications/subscription', payload);
